import { useTranslation } from 'react-i18next';

export const useAddEmployee = () => {
    const { t } = useTranslation();
    return { t };
};
